<div class="confirm-backdrop" role="presentation">
  <section class="confirm-dialog" role="dialog" aria-modal="true" [attr.aria-label]="'payments.confirm.title' | translate">
    <h3>{{ 'payments.confirm.title' | translate }}</h3>
    <p>
      {{ 'payments.confirm.body' | translate }}
      <strong>{{ plan?.name }}</strong>
      <strong *ngIf="price"> - {{ price.amountInCents | currencyAmount: price.currencyCode }}</strong>
    </p>
    <div class="confirm-dialog__actions">
      <button type="button" class="btn btn-outline-secondary" (click)="cancelled.emit()" [disabled]="isBusy">
        {{ 'common.cancel' | translateOr: 'Cancelar' }}
      </button>
      <button type="button" class="btn btn-primary" (click)="confirmed.emit()" [disabled]="isBusy">
        {{ (isBusy ? 'payments.creating_order' : 'payments.confirm.pay') | translate }}
      </button>
    </div>
  </section>
</div>
